module.exports = __webpack_public_path__ + "static/media/stedelijk.4f61a38a.jpg";